module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('invoice-number')) ? _c('div', {
    staticClass: "field-invoice-number"
  }, [_c('p', [_vm._v("INV" + _vm._s(_vm.item.internal_id) + "(" + _vm._s(_vm.item.number) + ")")])]) : (_vm.$is('invoice-emission-date')) ? _c('div', {
    staticClass: "field-emission-date"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Emission date:")]), (_vm.item.emission_date) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.emission_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-due-date')) ? _c('div', {
    staticClass: "field-due-date"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Due date:")]), (_vm.item.due_date) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-client-info')) ? _c('div', {
    staticClass: "field-client-info"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Client name:")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.billing_info.client_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.billing_info.organization_name))])], 1) : (_vm.$is('invoice-tax')) ? _c('div', {
    staticClass: "field-tax"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('span', [_vm._v("NET: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.item.subtotal))]), _c('br'), _c('span', [_vm._v("TAX: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.item.tax))])])]) : (_vm.$is('invoice-total')) ? _c('div', {
    staticClass: "field-total"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("TOTAL:"), _c('br'), _c('span', [_vm._v(_vm._s(_vm.currency) + " " + _vm._s(_vm.item.document_total))])])]) : (_vm.$is('invoice-paid-on')) ? _c('div', {
    staticClass: "field-paid-on"
  }, [(_vm.item.payed_on) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.payed_on, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-status')) ? _c('div', {
    staticClass: "field-status"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Status:")]), _c('p', [_vm._v(_vm._s(_vm.item.status))])]) : (_vm.$is('invoice-transaction')) ? _c('div', {
    staticClass: "field-transaction"
  }, _vm._l((_vm.item.transactions), function(transaction) {
    return (transaction.status === 'SUCCESS') ? _c('transaction', {
      attrs: {
        "item": transaction,
        "type": 'oneLook'
      }
    }) : _vm._e()
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b7c5600!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/InvoiceFields.vue
// module id = 2568
// module chunks = 1